import { orchestrator } from 'satcheljs';
import { updateIncludeDeclinedEvents } from 'owa-agenda-events-list';
import { toggleShowDeclinedEventsMode } from 'owa-show-declined-meetings-user-config';
import { AgendaScenarioId } from '../constants';

orchestrator(toggleShowDeclinedEventsMode, actionMessage => {
    updateIncludeDeclinedEvents(AgendaScenarioId, actionMessage.isDeclinedEventsMode);
});
